
document.addEventListener('DOMContentLoaded', function() {
  const vatToggles = document.querySelectorAll('.vat-toggle-checkbox');
  const vatStatusLabels = document.querySelectorAll('.vat-status-label');
  const body = document.body;

  function updateVatStatus(isInclusive) {
    if (isInclusive) {
      body.classList.add('vat-inclusive');
    } else {
      body.classList.remove('vat-inclusive');
    }
    localStorage.setItem('vat-inclusive', isInclusive);

    vatStatusLabels.forEach(label => {
      if(label) {
        label.textContent = isInclusive ? 'Inc VAT' : 'Ex VAT';
      }
    });

    vatToggles.forEach(toggle => {
      if(toggle) {
          toggle.checked = isInclusive;
      }
    });
  }
  
  const storedVatSetting = localStorage.getItem('vat-inclusive');
  const isVatInclusive = storedVatSetting === null ? false : storedVatSetting === 'true';
  updateVatStatus(isVatInclusive);

  vatToggles.forEach(toggle => {
    if (toggle) {
      toggle.addEventListener('change', function(e) {
        updateVatStatus(e.target.checked);
      });
    }
  });
});
